import cx from 'classnames';
import styles from './FdrCrossSellHeader.module.scss.js';
import { filterEmpty } from './fdrUtils/arrayUtils.js';
import Link from '../../Footer/components/Link.js';
import Icon from '../../Icon/Icon.js';
import { LinkBehaviour } from '../../../types/shared.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

const FdrCrossSellHeader = ({
  menuItems,
  testId = "ogFeLibraryFdrCrossSellHeader"
}) => {
  return /* @__PURE__ */ jsx("div", {
    className: styles.outerContainer,
    children: /* @__PURE__ */ jsx("div", {
      className: styles.container,
      "data-test-id": testId,
      children: filterEmpty(menuItems ?? []).map((item) => {
        const {
          text,
          url,
          behaviour
        } = item;
        const linkClassName = cx(styles.menuItem, {
          [styles.active]: url.includes("research")
        });
        const target = behaviour === LinkBehaviour.Standard ? "_self" : "_blank";
        const rel = behaviour === LinkBehaviour.Standard ? "_self" : "noopener noreferrer";
        return /* @__PURE__ */ jsx(Link, {
          href: url,
          testId: `${text} + ${url}`,
          className: linkClassName,
          "aria-label": `${text} link`,
          target,
          rel,
          children: /* @__PURE__ */ jsxs(Fragment, {
            children: [text, behaviour === LinkBehaviour.NewWindow && !url?.includes("research") && /* @__PURE__ */ jsx(Icon, {
              className: styles.icon,
              iconName: "icons.new-window",
              iconColor: "colorBaseWhite",
              "data-test-id": `cross-sell-header-icon`
            })]
          })
        }, `${text} + ${url}`);
      })
    })
  });
};

export { FdrCrossSellHeader as default };
//# sourceMappingURL=FdrCrossSellHeader.js.map
